"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDigitalEdition = void 0;
const digitalEditions = [
    'digitalStandard',
    'digitalDeluxe',
    'digitalSuper',
];
const isDigitalEdition = (edition) => {
    return digitalEditions.includes(edition);
};
exports.isDigitalEdition = isDigitalEdition;
